import Vue from 'vue';
import {DateTime} from 'luxon';
import { Product } from '@/products-and-services/ProductsAndServicesModels';

export function installFilters() {
    Vue.filter('shortDate', (value: string) => {
        return DateTime.fromISO(value, { zone: 'America/Chicago'}).toLocaleString(DateTime.DATE_SHORT);
    });
    Vue.filter('dotFormattedDate', (value: string) => {
        return DateTime.fromISO(value, { zone: 'America/Chicago'}).toFormat('MM.dd.yyyy');
    });
    Vue.filter('simpleTime', (value: string) => {
        return DateTime.fromISO(value, {zone: 'America/Chicago'}).toLocaleString(DateTime.TIME_SIMPLE);
    });
    Vue.filter('dateMedium', (value: string) : string => {
        return DateTime.fromISO(value, { zone: 'America/Chicago'}).toLocaleString(DateTime.DATE_MED);
    });
    Vue.filter('timeShortOffset', (value: string) : string => {
        return DateTime.fromISO(value, { zone: 'America/Chicago' }).toFormat('h:00 a ZZZZ');
    });
    Vue.filter('capitalize',  (value: string): string => {
        if (!value) {
            return '';
        }
        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
    });
    Vue.filter('mapTrueTo',  (value: string, trueValue: string): string => {
        return value ? trueValue : '';
    });
    Vue.filter('twoDecimalFormat',  (value: string): string => {
        if (value === '-') {
            return value
        }
        const value2Decimal = Number(value || '0').toFixed(2);
        return value2Decimal;
    });
    Vue.filter('textPlaceholder',  (value: string): string => {
        if(!value) {
            return 'DATA NEEDED';
        }
        return value;
    });
    Vue.filter('titleOrName',  ({name, title}: any): string => {
        if(title) {
            return title;
        }
        return name;
    });
    Vue.filter('currency', currencyFilter);
    Vue.filter('price', (item?: { totalAmount: string, amount: string }) => {
        if (typeof item === 'undefined' || (typeof item.totalAmount === 'undefined' && typeof item.amount === 'undefined')) {
            return '';
        }
        if (item.totalAmount === '' || item.amount === '') {
            return '';
        }
        if ((item.totalAmount && item.totalAmount.toString() === '0.00') || (item.amount && item.amount.toString() === '0.00') || (item.amount && item.amount.toString() === '0') ){
            return 'Free';
        }
        if ((item.totalAmount && item.totalAmount.toString() === '-99999') || (item.amount && item.amount.toString() === '-99999') ){
            return 'Select Options';
        }
        return currencyFilter(item.totalAmount || item.amount);
    });

    function currencyFilter(value: string|number): string {
        if (value === '-') {
            return '-';
        }
        if (Intl && Intl.NumberFormat) {
            return new Intl
            .NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(value));
        }
        return '$' + Number(value || '0').toFixed(2);
    }
}
